import React from "react";
import "./legal.css";

export default function TermsAndConditions() {
  const lastUpdated = "March 5, 2026";

  return (
    <div className="legal-page">
      <div className="legal-hero">
        <div className="legal-container">
          <p className="legal-badge">ingiwebservices</p>
          <h1 className="legal-title">Terms & Conditions</h1>
          <p className="legal-subtitle">
            These Terms govern your access to and use of our website and services.
          </p>
          <p className="legal-updated">Last updated: {lastUpdated}</p>
        </div>
      </div>

      <div className="legal-container legal-card">
        <section className="legal-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing our website or using our services, you agree to these Terms. If you do not agree, please do not
            use the website or services.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Services</h2>
          <p>
            ingiwebservices provides IT solutions including web development, mobile apps, cloud services, cybersecurity,
            digital marketing, and AI/automation. Service scope, pricing, and timelines may vary and will be defined in
            proposals, statements of work, or invoices.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. Quotes, Payments & Billing</h2>
          <ul>
            <li>Quotes are estimates unless stated otherwise in writing.</li>
            <li>Invoices are due as specified in your agreement or invoice terms.</li>
            <li>Late payments may pause delivery and/or incur reasonable late fees as permitted by law.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. Client Responsibilities</h2>
          <ul>
            <li>Provide accurate information, feedback, and required assets in a timely manner.</li>
            <li>Ensure you own or have rights to any content you provide (logos, images, text, data).</li>
            <li>Maintain access credentials securely and notify us of suspicious activity.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>5. Intellectual Property</h2>
          <p>
            Unless otherwise agreed in writing:
          </p>
          <ul>
            <li>We retain rights to our pre-existing tools, code libraries, templates, and know-how.</li>
            <li>Upon full payment, you receive rights to the final deliverables created specifically for you.</li>
            <li>Third-party licenses (fonts, plugins, stock media) remain subject to their own terms.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>6. Website Use & Prohibited Activities</h2>
          <p>You agree not to misuse the website. Prohibited actions include:</p>
          <ul>
            <li>Attempting to access systems or data without authorization.</li>
            <li>Disrupting site functionality (malware, scraping, DDoS, etc.).</li>
            <li>Using the site for unlawful, harmful, or fraudulent purposes.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>7. Disclaimers</h2>
          <p>
            The website and services are provided “as is” and “as available.” We disclaim warranties to the maximum
            extent permitted by law, including implied warranties of merchantability, fitness for a particular purpose,
            and non-infringement.
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, ingiwebservices will not be liable for indirect, incidental,
            consequential, special, or punitive damages, or any loss of profits, revenue, data, or goodwill.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Termination</h2>
          <p>
            We may suspend or terminate access if you violate these Terms or engage in activity that harms our business,
            users, or systems. Project termination terms (refunds, partial payments) will be governed by your agreement.
          </p>
        </section>

        <section className="legal-section">
          <h2>10. Changes to Terms</h2>
          <p>
            We may update these Terms periodically. Updates will be posted on this page with the revised “Last updated”
            date.
          </p>
        </section>

        <section className="legal-section">
          <h2>11. Contact</h2>
          <div className="legal-contact">
            <p><b>Email:</b> hello@ingiwebservices.com</p>
            <p><b>Phone:</b> +1 (800) 555-4567</p>
            <p><b>Address:</b> 200 Innovation Drive, San Jose, CA 95101</p>
          </div>
        </section>

        <div className="legal-footer-note">
          By continuing to use our website, you acknowledge you’ve read and agree to these Terms.
        </div>
      </div>
    </div>
  );
}